import { ScrollArea } from "@/modern/components/ui/scroll-area";
import { cn } from "@/modern/utils";

export const BaseModalBody = ({ children, className = "", contentElementClassName = "" }) => {
  return (
    <ScrollArea className={cn("swivu-react-base-modal-body flex-1 bg-background", contentElementClassName)}>
      <div className={cn("p-swivu-base h-full", className)}>{children}</div>
    </ScrollArea>
  );
};
